import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';

import { AgGridModule } from 'ag-grid-angular';
import { GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';

import { BAR_AG_GRID_LOCALE, themeLv } from '@lvflanders/bar-ng-ag-grid';
import { BarI18nPipe } from '@lvflanders/bar-ng-ui';

import { TestprofielDto } from '../../../api/models';
import { TestprofielApiService } from '../../../api/services';

const GRID_PAGE_SIZE = 10;

export type StartschermTestProfileDialogData = {
    toepassingscode?: string;
};

@Component({
    selector: 'startscherm-test-profile-dialog',
    templateUrl: './startscherm-test-profile-dialog.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatDialogTitle, MatDialogContent, AgGridModule, MatDialogActions, MatButton, MatDialogClose, BarI18nPipe]
})
export class StartschermTestProfileDialog {
    readonly #data = inject<StartschermTestProfileDialogData>(MAT_DIALOG_DATA);
    readonly #testprofielService = inject(TestprofielApiService);
    readonly #dialogRef = inject(MatDialogRef<StartschermTestProfileDialog>);

    protected readonly gridOptions = {
        paginationPageSizeSelector: false,
        defaultColDef: {
            sortable: true,
            resizable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true
        },
        pagination: true,
        paginationPageSize: GRID_PAGE_SIZE,
        localeText: BAR_AG_GRID_LOCALE,
        theme: themeLv,
        // avoid resize observer error
        suppressBrowserResizeObserver: true,
        suppressContextMenu: true,
        enableCellTextSelection: true,
        columnDefs: [
            { headerName: 'Toepassingscode', field: 'toepassingscode', width: 200 },
            { headerName: 'Naam', field: 'naam', width: 200 },
            { headerName: 'Omschrijving', field: 'omschrijving', width: 600 }
        ]
    } as GridOptions<TestprofielDto>;

    #gridApi: GridApi<TestprofielDto> | undefined;

    protected onGridReady(params: GridReadyEvent) {
        this.#gridApi = params.api;
        this.#init();
    }

    protected testProfileSelected(testProfile: TestprofielDto) {
        const result = { result: 'OK', testProfielSelected: `${testProfile.toepassingscodeAndNaamBackslash}` };
        this.#dialogRef.close({ event: 'close', data: result });
    }

    #init() {
        this.#testprofielService.getTestprofielen().subscribe((rowData) => {
            if (!this.#gridApi) return;
            this.#gridApi.setGridOption('rowData', rowData);
            this.#gridApi.sizeColumnsToFit();
            if (this.#data.toepassingscode) {
                const filterModel = this.#gridApi.getFilterModel();
                filterModel.toepassingscode = { filterType: 'text', type: 'startsWith', filter: this.#data.toepassingscode };
                this.#gridApi.setFilterModel(filterModel);
            }
        });
    }
}
